var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TalktoExpert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.674,
    height: 27.673,
    viewBox: "0 0 27.674 27.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15153",
    "data-name": "Path 15153",
    d: "M22.647,30.163h.039a2.735,2.735,0,0,0,1.944-.811L28.383,25.6a1.382,1.382,0,0,0,0-1.957l-5.535-5.535a1.382,1.382,0,0,0-1.957,0l-2.206,2.206a10.363,10.363,0,0,1-4.14-2.206,10.362,10.362,0,0,1-2.206-4.14l2.206-2.206a1.382,1.382,0,0,0,0-1.957L9.01,4.27a1.424,1.424,0,0,0-1.957,0L3.3,8.023a2.765,2.765,0,0,0-.811,1.986A21.176,21.176,0,0,0,8.439,24.217,21.173,21.173,0,0,0,22.647,30.163ZM8.033,7.205l3.578,3.578L9.823,12.573a1.379,1.379,0,0,0-.375,1.262,14.056,14.056,0,0,0,3.142,6.23,14.056,14.056,0,0,0,6.23,3.142,1.376,1.376,0,0,0,1.262-.375l1.789-1.789,3.578,3.578L22.673,27.4A18.32,18.32,0,0,1,10.4,22.259,18.324,18.324,0,0,1,5.259,9.98ZM27.4,14.942h2.767A12.186,12.186,0,0,0,17.7,2.49V5.257A9.374,9.374,0,0,1,27.4,14.942Z",
    transform: "translate(-2.491 -2.49)",
    fill: "#a33635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15154",
    "data-name": "Path 15154",
    d: "M10.95,8.333c2.91,0,4.151,1.241,4.151,4.151h2.767c0-4.463-2.456-6.919-6.919-6.919Z",
    transform: "translate(4.269 -0.031)",
    fill: "#a33635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallUs);
export default __webpack_public_path__ + "static/media/CallUS.04a00f72f4297f1a0c914fba2cd25e4f.svg";
export { ForwardRef as ReactComponent };